<template>
  <Teleport to="#app">
    <div class="modal absolute p-6 flex justify-center items-center">
      <div v-if="y && yTransform" class="panel-wrapper relative">
        <div class="absolute shadow-xl bg-white rounded-lg p-6"
          :style="{
            'transform': `${translate}`,
            'left': '50%',
            'top': `${y}%`
          }">
          <slot />
        </div>
      </div>
      <div v-else class="panel-wrapper relative flex items-center justify-center">
        <div class="shadow-xl bg-white rounded-lg p-6">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  y: {
    type: [String, Number],
    required: false
  },
  yTransform: {
    type: [String, Number],
    required: false
  }
})
// todo: get rid of this asap
const translate = ref(`translate(-50%, -${props.yTransform}%)`)

</script>

<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
  overflow-x: hidden;
  z-index: 1000;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow-y: scroll;
}

.panel-wrapper {
  width: 100%;
  height: 100%;
}
</style>
